<div class="company-property-detail" data-automation-id="company-property-detail">
	@if (propertyId) {
		<app-sub-nav
			parentTitle="Properties"
			i18n-parentTitle="@@companyProperties"
			[title]="propertyName"
			queryParamKey="propertyTab"
			(parentTitleClick)="onPropertiesClick()"
		>
			<ng-template
				appSubNavTab
				label="Details"
				i18n-label="@@property-detailsAbout"
				automationId="company-property-details-tab"
			>
				<app-property-about [appBreadcrumbLabel]="breadcrumbLabel" [propertyId]="propertyId"></app-property-about>
			</ng-template>

			<ng-template
				appSubNavTab
				label="Devices"
				i18n-label="@@property-detailsDevices"
				automationId="company-property-devices-tab"
			>
				<!-- ITE-13208: Devices tab content -->
				<div class="company-property-tab-stub" data-automation-id="company-property-devices-stub"></div>
			</ng-template>

			@if (canViewClients) {
				<ng-template
					appSubNavTab
					label="Clients"
					i18n-label="@@property-detailsClients"
					automationId="company-property-clients-tab"
				>
					<!-- ITE-13208: Clients tab content -->
					<div class="company-property-tab-stub" data-automation-id="company-property-clients-stub"></div>
				</ng-template>
			}
		</app-sub-nav>
	}
</div>
